export default __webpack_public_path__ + "static/media/style-belgardUrbana.211716ab.jpg";